import React from "react";
import { usePlacesWidget } from "react-google-autocomplete";
import { Input } from "reactstrap";
const YOUR_GOOGLE_MAPS_API_KEY = "AIzaSyAB5XSyVYR2z02yBp9EiMY_S3HgyyGmdvM";
export default ({
  type,
  className,
  id,
  placeholder,
  required,
  onPlaceSelected,
  style,
}) => {
  const { ref } = usePlacesWidget({
    options: {
      types: [],
    },
    apiKey: YOUR_GOOGLE_MAPS_API_KEY,
    onPlaceSelected,
  });
  return (
    <Input
      style={style}
      innerRef={ref}
      type={type}
      className={className}
      id={id}
      placeholder={placeholder}
      required={required}
      autoComplete="new-password"
      onFocus={(event) => {
        event.target.setAttribute('autocomplete', 'new-password');
      }}
    />
  );
};
